import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Updater } from 'use-immer';

const DeleteConfirm = ({
  payload,
  modal,
  action,
}: {
  payload: { show: boolean; comment_id: string };
  modal: Updater<{
    show: boolean;
    comment_id: string;
  }>;
  action(comment_id: string): void;
}): JSX.Element => {
  return (
    <Transition
      show={(payload.show && payload.comment_id.length > 0) || false}
      as={Fragment}
    >
      <Dialog
        as="div"
        className="relative z-[10001]"
        onClose={() => {
          modal(draft => {
            draft.show = false;
            draft.comment_id = '';
          });
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Xác nhận xoá
                </Dialog.Title>
                <div className="mt-2 py-4">
                  <p className="text-sm text-gray-500">
                    Bạn có chắc chắn muốn xoá. Điều này là không thể khôi phục.
                  </p>
                </div>

                <div className="mt-4 flex justify-between">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                    onClick={() => {
                      action(payload.comment_id);
                    }}
                  >
                    Xoá
                  </button>
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={() => {
                      modal(draft => {
                        draft.show = false;
                        draft.comment_id = '';
                      });
                    }}
                  >
                    Huỷ
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default DeleteConfirm;
